module.exports = __webpack_public_path__ + "static/img/index-tech-right-bg.d6e1254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index-tech-right-bg.png
// module id = c73B
// module chunks = 1